<template>
  <div class="contain">
    <div class="inner posa"> 
     <span @click="exit"><i class="iconfont icon-guanbi posa"></i></span>
      <!--身份证框-->
      <div class="img">  
        <img src="../assets/images/logo.png">
      </div>
      <div class="inputbox posr">

        <!-- 姓名框 -->
        <input type="text" placeholder="请输入姓名"
               @blur="checkPwd"
               :class="{red:isRedp}"
               @keyup.enter="_login"
               v-model="xm">
        <input type="text"
               :class="{red:isRedu}"
               placeholder="请输入身份证号码"
               @blur="checkUser"
               @keyup.enter="_login"
               v-model="userLogin">
        <!-- 批次 -->
        <Select style="width:400px;margin-top:15px;" v-model="batch_id" size="large"  :disabled='disabled'
                placeholder="请选择批次" >
          <Option v-for="(key,value) in batchList" :value="key.id" :key="value">{{ key.name }}</Option>
        </Select>
      </div>
      <div class="loginbtn">
        <button id="login" class="l" @click="_login">{{buttonValue}}</button>
      </div>
      <tip :tip="tip" v-show="tipShow"></tip>
    </div>
  </div>
</template>

<script>
import { getBatchList, login } from "../api/login";
export default {
  components: {},
  data() {
    return {
      batch_id: "", //保存批次id
      userLogin: "", //保存登录用户名
      xm: "", //保存登录密码
      tipShow: false,
      tip: "", //tip提示
      isRedu: false,
      isRedp: false, //控制异常情况边框颜色
      batchList: [], //批次列表
      disabled: true, //控制下拉框禁用
      selected: false,
      buttonValue: "登录"
    };
  },
  methods: {
    //验证用户名
    checkUser() {
      let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      //判断身份证号是否存在
      if (!this.userLogin) {
        this.isRedu = true;
        this.tipCtr("请输入身份证号码");
        return false;
      } else if (!reg.test(this.userLogin)) {
        this.isRedu = true;
        this.tipCtr("请输入正确的身份证号码");
        return false;
      } else {
        // 当身份证号全部正确触发获取批次接口
        this.isRedu = false;
        this._getBatchList();
        return true;
      }
    },

    // 验证用户名密码
    checkPwd() {
      let reg = /^[\u4E00-\u9FA5\uf900-\ufa2d]{2,4}$/;
      if (!this.xm) {
        this.isRedp = true;
        this.tipCtr("请输入姓名");
        return false;
      } else if (!reg.test(this.xm)) {
        this.tipCtr("请输入正确的姓名");
        this.isRedp = true;
      } else {
        this.isRedp = false;
        return true;
      }
    },

    //获取批次
    _getBatchList() {
      let module = {
        sfzjh: this.global.Base64.encode(this.userLogin)
      };
      getBatchList(module)
        .then(res => {
          if (res.status) {
            this.disabled = false;
            this.batchList = res.data;
          } else {
            this.batchList = {};
            this.tipCtr("暂无数据");
          }
        })
        .catch(() => {
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },

    // 登录按钮
    _login() {
      if (this.checkUser() && this.checkPwd()) {
        let module = {
          sfzjh: this.global.Base64.encode(this.userLogin),
          batch_id: this.batch_id,
          xm: this.xm
        };
        this.buttonValue = "登录中...";
        login(module)
          .then(res => {
            this.buttonValue = "登录";
            if (res.status) {
              // 关闭登弹窗
              this.$emit("close");

              //本地存储
              sessionStorage.clear();
              //本地存储
              sessionStorage.setItem(
                "INFO",
                this.global.Base64.encode(JSON.stringify(res.data.data))
              );
              this.$emit("control");
            } else {
              this.tipCtr(res.msg);
            }
          })
          .catch(() => {
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        this.checkUser() && this.checkPwd();
      }
    },
    // 返回按钮，关闭弹窗
    exit() {
      this.$router.back();
    },
    //tip控制方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1500);
    }
  }
};
</script>

<style scoped>
.contain {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  background: url(../assets/images/bg.1.jpg) no-repeat center;
  background-size: cover;
}

.inner {
  width: 450px;
  height: 400px;
  top: 50%;
  left: 50%;
  margin-left: -200px;
  margin-top: -250px;
  border-radius: 10px;
  box-shadow: 0 0 10px #333;
}

.icon-guanbi {
  top: 10px;
  right: 12px;
  font-size: 16px;
  cursor: pointer;
}

.img {
  height: 50px;
  text-align: center;
  margin: 30px 0 20px 0;
  cursor: pointer;
}

input:focus {
  border-color: #80c6ee !important;
}

.inputbox {
  width: 400px;
  margin: 0 auto;
}

.inputbox input {
  width: 100%;
  height: 34px;
  margin-top: 15px;
  border-radius: 5px;
  border: solid 1px #dbdbdb;
  text-indent: 15px;
  background: white;
}
.inputbox div {
  width: 100%;
  line-height: 30px;
  text-align: right;
}
.inputbox div span:hover {
  color: #80c6ee;
}
.iconfont {
  color: #1e76a8;
}
.loginbtn {
  width: 350px;
  height: 40px;
  text-align: center;
  margin: 0 auto;
}

.loginbtn button {
  width: 350px;
  height: 40px;
  border-radius: 8px;
  font-size: 16px;
  background-color: #1e76a8;
  margin-top: 50px;
  color: white;
  outline: none;
  border: none;
}
.l {
  float: left;
}
.r {
  float: right;
}
.loginbtn button:hover {
  background-color: #2d9fe0;
}

.inputbox input.red {
  border: 1px solid red;
}

* {
  font-family: "Microsoft YaHei";
}

input[type="number"] {
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue